import { render } from "./MoolngContextMenu.vue?vue&type=template&id=fbc195b2"
import script from "./MoolngContextMenu.vue?vue&type=script&lang=js"
export * from "./MoolngContextMenu.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__